import {DateTime} from "luxon";

export default function utcToLocal(isoString: string, format: string = 'yyyy-LL-dd ttt'): string {

    return DateTime.fromISO(isoString, { zone: "UTC"}).toLocal().toFormat(format);
};